import { useEffect, useState } from 'react';

function format(tz) {
  try {
    return new Intl.DateTimeFormat('en-IE', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: tz,
    }).format(new Date());
  } catch {
    return '--:--';
  }
}

export function useLocalTime(tz) {
  const [time, setTime] = useState(() => format(tz));

  useEffect(() => {
    const id = setInterval(() => setTime(format(tz)), 15000);
    return () => clearInterval(id);
  }, [tz]);

  return time;
}
